import {
  AdapterSource,
  DispatcherAuthPrefix,
  DispatcherCategoryService,
  DispatcherEndpoint,
  DispatcherResource
} from 'modules/types/common';
import { getDispatcherUrl } from 'modules/utils/UrlUtils';
import { Dispatch } from 'redux';
import { DFDHeaders } from 'serverTypes/authentication';
import { RootState } from 'store/types';

export const SNOOZE_HEALTH_ADVISORY_CARD = 'HEALTH_ADVISORY.SNOOZE_HEALTH_ADVISORY_CARD';
export const SNOOZE_HEALTH_ADVISORY_CARD_RESET =
  'HEALTH_ADVISORY.SNOOZE_HEALTH_ADVISORY_CARD_RESET';
export const SNOOZE_HEALTH_ADVISORY_CARD_SUCCESS =
  'HEALTH_ADVISORY.SNOOZE_HEALTH_ADVISORY_CARD_SUCCESS';
export const SNOOZE_HEALTH_ADVISORY_CARD_FAIL = 'HEALTH_ADVISORY.SNOOZE_HEALTH_ADVISORY_CARD_FAIL';

export const snoozeHealthAdvisoryItem = (eventId: String, data: object) => async (
  dispatch: Dispatch,
  getState: () => RootState
) => {
  const headers = {
    [DFDHeaders.resourceId]: eventId,
    [DFDHeaders.mhpAdapter]: AdapterSource.UTAH
  };

  await dispatch({
    type: SNOOZE_HEALTH_ADVISORY_CARD,
    payload: {
      client: 'dispatcher',
      request: {
        headers,
        method: 'patch',
        url: getDispatcherUrl(
          DispatcherCategoryService.HEALTH_RECORDS,
          DispatcherAuthPrefix.AUTHENTICATED,
          DispatcherResource.HEALTH_ADVISORIES,
          DispatcherEndpoint.SNOOZE
        ),

        data
      }
    }
  });

  return dispatch({ type: SNOOZE_HEALTH_ADVISORY_CARD_RESET });
};
